module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/299f16fedb6ad60258ddb6be6c972f41.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze4.svg
// module id = UIQG
// module chunks = 1